// extracted by mini-css-extract-plugin
export var disabled = "_1g-a";
export var hierarchyLinkGray = "_1g-4";
export var hierarchyLinkUnderline = "_1g-3";
export var hierarchyPrimary = "_1g-0";
export var hierarchySecondary = "_1g-1";
export var hierarchyTertiary = "_1g-2";
export var pressed = "_1g-6";
export var themeAction = "_1g-5";
export var themeDestructive = "_1g-8";
export var themeNormal = "_1g-7";
export var themeSuccess = "_1g-9";